<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right"
                     style="width: 80%;float: left;">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <router-link to="/invoice-apply/pre-received/table?issued_type=2"
                   v-if="!$route.meta.is_pre_received"
                   style="float: right;">
        预收款开票管理
      </router-link>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="开票ID"
                        key="id"
                        prop="id">
            <el-input v-model="search.id"
                      clearable
                      placeholder="请输入开票ID">
            </el-input>
          </el-form-item>
          <el-form-item label="客户名称"
                        prop="customerid">
            <remote-select style="width: 100%;"
                           v-model="search.customerid"
                           filterable
                           remote
                           clearable
                           id-key="number"
                           keyword-key="name"
                           :label="customerLabel"
                           value-key="id"
                           placeholder="请输入客户名称/编号搜索"
                           :query-request="customerRemoteMethod"
                           @change="search.projectid=null"
                           :find-request="getCustomerInfoRemote">
            </remote-select>
          </el-form-item>
          <el-form-item label="BO审批"
                        v-if="isSearchItemDisplay()"
                        prop="bu_approver">
            <remote-select style="width: 100%;"
                           v-model="search.bu_approver"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入管理员名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="申请描述"
                        v-if="isSearchItemDisplay()"
                        prop="desc">
            <el-input style="width: 100%;"
                      v-model="search.desc"
                      clearable
                      placeholder="请输入申请描述关键字搜索">
            </el-input>
          </el-form-item>

          <el-form-item label="开票状态"
                        v-if="isSearchItemDisplay()"
                        prop="status">
            <el-select v-model="search.status"
                       clearable
                       multiple
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        v-if="isSearchItemDisplay()"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开票日期"
                        v-if="isSearchItemDisplay()"
                        prop="invoice_time">
            <el-date-picker v-model="search.invoice_time"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="开票金额"
                        v-if="isSearchItemDisplay()">
            <el-col :span="11">
              <el-form-item prop="total_amount_min">
                <el-input v-model="search.total_amount_min"
                          clearable
                          placeholder="请输入含税金额起始值"/>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div>&nbsp;&nbsp;至&nbsp;&nbsp;</div>
            </el-col>
            <el-col :span="11"
                    :offset="1">
              <el-form-item prop="total_amount_max">
                <el-input v-model="search.total_amount_max"
                          clearable
                          placeholder="请输入含税金额结束值"/>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="项目编号"
                        prop="project_number">
            <el-input style="width: 100%;"
                      v-model="search.project_number"
                      clearable
                      placeholder="请输入项目编号搜索">
            </el-input>
          </el-form-item>

          <el-form-item label="开票类别"
                        prop="issued_type">
            <el-select v-model="search.issued_type"
                       clearable
                       :disabled="$route.meta.is_pre_received"
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.issued_type"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发起人"
                        prop="initiator">
            <remote-select style="width: 100%;"
                           v-model="search.initiator"
                           filterable
                           remote
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入发起人名称搜索"
                           :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]}))"
                           :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>

          <!-- 仅预收款开票页面展示抵扣状态搜索项 -->
          <el-form-item label="抵扣状态"
                        v-if="$route.meta.is_pre_received && isSearchItemDisplay()"
                        prop="deduction_status">
            <el-select v-model="search.deduction_status"
                       clearable
                       @change="changeDeductionStatus"
                       class="width-max"
                       placeholder="请选择">
              <el-option
                v-for="item in options.deduction_status"
                :key="item.value"
                :label="item.label"
                :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票主体"
                        prop="subject">
            <remote-select class="width-max"
                           clearable
                           id-key="id"
                           keyword-key="name"
                           label-key="name"
                           value-key="id"
                           placeholder="仅支持搜索启用中的开票主体公司,可输入名称进行搜索"
                           v-model="search.subject"
                           :query-request="(_)=>getFinCenterOurCompaniesTable(Object.assign(_, {is_disabled: 0}))"
                           :find-request="getFinCenterOurCompaniesDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="回款状态"
                        prop="received_payment_status">
            <el-select v-model="search.received_payment_status"
                       clearable
                       class="width-max">
              <el-option v-for="item in receivedPaymentStatus"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="回款日期"
                        prop="collection_date">
            <el-date-picker v-model="search.collection_date"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="info"
                   @click="createInvoiceApply"
                   size="small">添加开票申请
        </el-button>
        <el-button type="primary"
                   size="small"
                   @click="onExportSearchFix()">搜索结果导出
        </el-button>
        <!--计算搜索结果价税合计加起来的数值并展示-->
        <el-button type="primary"
                   size="small"
                   @click="openSumTaxedAmountDialog">按搜索结果汇总
        </el-button>

        <el-button type="success"
                   style="float:right;"
                   v-if="$route.meta.type !== 'approval'"
                   @click="redirectToApproveTable"
                   size="small">查看待审批
        </el-button>

        <el-button type="primary"
                   @click="batchDownloadPdf"
                   :disabled="mulSelection.length < 1"
                   size="small">批量生成PDF
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @selection-change="(val) => this.mulSelection = val.map(item => item.id)"
                @sort-change="sortChange">
        <el-table-column type="selection"
                         width="40">
        </el-table-column>
        <el-table-column prop="id"
                         label="ID"
                         sortable="custom"
                         min-width="90"></el-table-column>
        <el-table-column prop="desc"
                         key="desc"
                         label="申请描述"
                         min-width="120">
          <template slot-scope="scope">
            <div @click="openDetail(scope.row.id)"
                 style="color: #409EFF;cursor: pointer;">
              {{ scope.row.desc }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="customer_number"
                         key="customer_number"
                         label="客户编号"
                         width="190">
          <template slot-scope="scope">
            <!--客户名/编号-->
            {{ scope.row.customer_name }}/{{ scope.row.customer_number }}
          </template>
        </el-table-column>
        <el-table-column prop="receipt_info_company_name"
                         key="receipt_info_company_name"
                         label="公司名称"
                         width="190">
        </el-table-column>
        <!--   预收款发票的虚拟项目编号信息     -->
        <el-table-column prop="virtual_project"
                         key="virtual_project"
                         label="项目编号"
                         v-if="$route.meta.is_pre_received"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.virtual_project.name }}/{{ scope.row.virtual_project.number }}
          </template>
        </el-table-column>
        <el-table-column prop="issued_type"
                         key="issued_type"
                         label="开票类别"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.issued_type"
                  v-if="scope.row.issued_type * 1 === item.value * 1">
              {{ item.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         key="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="scope.row.status === item.value"
                  :style="{color: item.color}">{{ item.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deduction_status"
                         key="deduction_status"
                         v-if="$route.meta.is_pre_received"
                         label="抵扣状态"
                         min-width="120">
          <template slot-scope="scope">
              <span v-for="item in options.deduction_status"
                    v-if="scope.row.deduction_status * 1 === item.value * 1">
                {{ scope.row.status * 1 === 7 ? item.label : '-' }}
              </span>
          </template>
        </el-table-column>
        <!--   预收款发票不显示未税金额     -->
        <el-table-column prop="untaxed_amount"
                         key="untaxed_amount"
                         label="未税开票金额"
                         v-if="!$route.meta.is_pre_received"
                         min-width="120">
          <template slot-scope="scope">
            <span :style="amountStyle(scope.row)">
              ￥{{ scope.row.untaxed_amount | seperateThousandsToFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="total"
                         key="total"
                         label="含税开票金额"
                         min-width="120">
          <template slot-scope="scope">
            <span :style="amountStyle(scope.row)">
              ￥{{ scope.row.total | seperateThousandsToFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="customer_number"
                         label="回款状态"
                         width="190">
          <template slot-scope="scope">
            {{ showRefundStatus(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="collection_remains_total"
                         label="待回款金额"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.collection_remains_total }}
          </template>
        </el-table-column>
        <el-table-column prop="collection_total"
                         label="已回款金额"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.collection_total }}
          </template>
        </el-table-column>

        <!--   以下字段仅在预收款发票页面展示     -->
        <template v-if="$route.meta.is_pre_received">
          <el-table-column prop="available_deduct_amount"
                           key="available_deduct_amount"
                           label="可用抵扣金额"
                           min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status * 1 === 7">
                ￥{{ scope.row.available_deduct_amount | seperateThousandsToFixed(2) }}
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freeze_deduct_amount"
                           key="freeze_deduct_amount"
                           label="冻结抵扣金额"
                           min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status * 1 === 7">
                ￥{{ scope.row.freeze_deduct_amount | seperateThousandsToFixed(2) }}
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="deducted_amount"
                           key="deducted_amount"
                           label="已抵扣金额"
                           min-width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.status * 1 === 7">
                ￥{{ scope.row.deducted_amount | seperateThousandsToFixed(2) }}
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="initiator_name"
                         key="initiator_name"
                         label="发起人"
                         min-width="120"></el-table-column>
        <el-table-column prop="bu_name"
                         key="bu_name"
                         label="BO审批"
                         min-width="120"></el-table-column>
        <el-table-column label="创建时间 更新时间"
                         key="updated_at"
                         min-width="180"
                         prop="updated_at"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.created_at }} <br/>
            {{ scope.row.updated_at }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :key="`operation`"
                         width="200px">
          <template slot-scope="scope">
            <operation-buttons :scope="scope"
                               @refresh="onRefresh"
                               @approveInvoice="approve"
                               @confirmInvoice="confirm"
                               @returnInvoice="returnReceipt"
                               @abandonInvoice="abandon">
            </operation-buttons>

            <div v-if="isShowDeductBtn(scope.row)"
                 style="margin-top: 5px;">
              <button-gutter>
                <el-button type="primary"
                           size="mini"
                           v-if="scope.row.initiator * 1 === user.id * 1 && scope.row.available_deduct_amount !== 0"
                           @click="applyDeduct(scope.row)">抵扣申请
                </el-button>
                <el-button type="danger"
                           size="mini"
                           v-if="isShowAbandonBtn(scope.row)"
                           @click="abandonDeduct(scope.row)">放弃抵扣
                </el-button>
                <el-button type="warning"
                           size="mini"
                           v-if="isShowApproveBtn(scope.row)"
                           @click="approveDeduct(scope.row)">抵扣-BO审批
                </el-button>
              </button-gutter>
            </div>
          </template>

        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <sum-taxed-amount-dialog :visible="sumVisible"
                             :amountStatistics="amountStatistics"
                             :title="title"
                             :isPreReceivedPage="$route.meta.is_pre_received"
                             @closeDialog="sumVisible=false">
    </sum-taxed-amount-dialog>

    <el-dialog title="预收款发票导出错误"
               :visible="exportErrVisible"
               width="50%"
               @close="closeExportErrDialog">
      <span>搜索结果中无已签收的预收款发票，或者所有已签收的预收款发票中不存在抵扣成功的条目数据</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeExportErrDialog">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import downloadJS from '@/vendor/download'
import OperationButtons from '@/views/invoice-apply/components/OperationButtons'
import SumTaxedAmountDialog from '@/views/invoice-apply/components/SumTaxedAmountDialog'
import dateTimePicker from '@core/mixins/dateTimePicker'
import selectRemote from '@core/mixins/selectRemote'
import table, { removeEmptyParams } from '@core/mixins/table'
import { getToken } from '@utils/auth'
import RemoteSelect from '@core/components/RemoteSelect'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  components: {
    RemoteSelect,
    OperationButtons,
    SumTaxedAmountDialog,
  },
  data () {
    return {
      search: {
        id: null,
        status: [],
        customerid: null,
        bu_approver: null,
        initiator: null,
        created_at: [],
        invoice_time: [],
        sort_by_updated_at: null,
        sort_by_id: null,
        total_amount_min: null,
        total_amount_max: null,
        project_number: null,
        issued_type: null,
        deduction_status: null,
        received_payment_status: null,
        subject: null,
        collection_date: [],
      },
      searchFieldType: {
        customerid: String,
        bu_approver: Number,
        initiator: Number,
        total_amount_min: Number,
        total_amount_max: Number,
        project_number: String,
        received_payment_status: Number,
        subject: Number,
      },
      exportErrVisible: false,
      sumVisible: false,
      title: null,
      amountStatistics: [],
      paymentCompanies: {},
      mulSelection: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.invoiceApply.options,
      user: state => state.login.user,
      exportHeader: state => state.invoiceApply.receipt_export_headers,
      exportPreHeader: state => state.invoiceApply.pre_receipt_export_headers,
      receivedPaymentStatus: state => state.invoiceApply.options.received_payment_status,
    }),
  },
  created () {
    this.setDefaultStatus()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => { vm.getFinCenterConfigs() })
  },
  beforeRouteLeave (to, from, next) {
    // 离开时，清除当前页面设置的查询参数，避免在其他的提现页面保留这些查询参数
    if (this.$route.meta.is_pre_received) { this.search.issued_type = null }
    Object.assign(this.$data, this.$options.data.call(this))
    next()
  },
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map(['getFinCenterOurCompaniesTable', 'getFinCenterOurCompaniesDetail']),
    setDefaultStatus () {
      this.search.status = this.$route.query.status || null
    },
    isFromTodoAudit () {
      return this.$route.meta.type === 'approval'
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      this.search.is_from_todo_audit = this.isFromTodoAudit()
      params.is_from_todo_audit = this.isFromTodoAudit()
      return request.page('getInvoiceApplyTable', params)
    },
    sortChange (column, prop, order) {
      this.search.sort_by_id = this.search.sort_by_updated_at = null
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'id') {
        this.search.sort_by_id = sortBy
      } else if (column.prop === 'updated_at') {
        this.search.sort_by_updated_at = sortBy
      }
      this.onSearch()
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      if (this.$route.meta.is_pre_received) {
        this.search.issued_type = '2'
      }
    },
    getExportData (params) {
      if (this.$route.meta.is_pre_received) {
        // 预收款发票数据导出,未指定状态时,锁定导出已签收状态的发票
        if (!params.status) {
          params.status = [7]
        }
        params.has_passed_deduction = 1
        return request.page('getExportPreReceivedApproveTable', params)
      }
      return request.page('getExportApproveTable', params)
    },
    onExportSearchFix () {
      let params = filter.copyJson(removeEmptyParams(this.search))
      params.per_page = 1
      params.is_from_todo_audit = this.isFromTodoAudit()
      this.getExportData(params).then(({data}) => {
        if (data.data.length < 1 && this.$route.meta.is_pre_received) {
          this.exportErrVisible = true
        } else {
          this.onExportSearch()
        }
      })
    },
    onExportSearch () {
      const fileHeader = this.$route.meta.is_pre_received ? this.exportPreHeader : this.exportHeader
      this.$export(this.$route.meta.title, {
        fileHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: {...this.search, is_from_todo_audit: this.isFromTodoAudit()},
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        row.tax_rate = row.tax_rate + '%'
        row.buyer_company_name = row.receipt_info_json.company_name || '' // 购买方公司名称
        row.buyer_tax_number = row.receipt_info_json.tax_number || '' // 购买方纳税人识别号
        row.quantity = row.quantity > 0 ? row.quantity : '' // 数量大于0时显示数字
        this.options.tax_type.forEach((status) => {
          if (status.value * 1 === row.invoice_tax_type * 1) {
            row.invoice_tax_type_cn = status.label
          }
        })
        this.options.status.forEach((status) => {
          if (status.value * 1 === row.status * 1) {
            row.status = status.label
          }
        })
        this.options.issued_type.forEach((issuedType) => {
          if (issuedType.value * 1 === row.issued_type * 1) {
            row.issued_type = issuedType.label
          }
        })
        if (row.subject) {
          row.subject = this.paymentCompanies[row.subject]
        }
        this.options.type.forEach(type => {
          if (type.value * 1 === row.type * 1) {
            row.type = type.label
          }
        })
        if (row.deduction_status) {
          this.options.deduction_status.forEach((deductType) => {
            if (deductType.value * 1 === row.deduction_status * 1) {
              row.deduction_status = deductType.label
            }
          })
        }
      })
      return data
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportInvoiceApplyData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    customerRemoteMethod (query) {
      return request.common('getCustomerTable', {keyword: query.name, type: [10, 70]})
    },
    getCustomerInfoRemote () {
      return request.common('getCustomerDetail', {id: this.search.customerid})
    },
    customerLabel (item) {
      return item.name + '/' + item.number
    },
    openDetail (id) {
      this.$router.push(`/invoice-apply/detail/${id}?type=detail&from=apply`)
    },
    approve (id) {
      // 开票申请 - BO审批'
      this.$router.push(`/invoice-apply/review/bu-review/${id.id}`)
    },
    approveDeduct (id) {
      // 开票申请 - 抵扣-BO审批
      this.$router.push(`/invoice-apply/review/bu-deduct/${id.id}`)
    },
    abandonDeduct (id) {
      // 开票申请 - 放弃抵扣
      this.$router.push(`/invoice-apply/review/waiver-deduct/${id.id}`)
    },
    applyDeduct (id) {
      // 开票申请 - 抵扣申请
      this.$router.push(`/invoice-apply/review/deduct-apply/${id.id}`)
    },
    confirm (id) {
      // 开票申请 - 客户签收
      this.$router.push(`/invoice-apply/review/signed-off/${id.id}`)
    },
    returnReceipt (id) {
      // 开票申请 - 申请退票
      this.$router.push(`/invoice-apply/review/return/${id.id}`)
    },
    abandon (id) {
      // 开票申请 - 放弃申请
      this.$router.push(`/invoice-apply/review/abandon/${id.id}`)
    },
    closeExportErrDialog () {
      this.exportErrVisible = false
    },
    async openSumTaxedAmountDialog () {
      this.amountStatistics = []
      let params = removeEmptyParams(filter.copyJson(this.search))
      params.is_from_todo_audit = this.isFromTodoAudit()
      if (this.$route.meta.is_pre_received) {
        params.issued_type = '2'
        params.status = ['7']
        await request.common('getPrepareInvoiceAmountTotal', params).then((data) => {
          let totalLength = 0
          let totalAvailableAmount = 0
          let totalFreezeAmount = 0
          let totalDeductedAmount = 0
          for (const i in data.data) {
            if (data.data.hasOwnProperty(i)) {
              totalLength += data.data[i].length
              totalAvailableAmount += data.data[i].available_deduct_amount
              totalFreezeAmount += data.data[i].freeze_deduct_amount
              totalDeductedAmount += data.data[i].deducted_amount
              this.amountStatistics.push(data.data[i])
            }
          }
          if (totalLength) {
            this.amountStatistics.push({
              'deduction_status': -1, // -1 为 总计 列，需单独处理显示文字
              'length': totalLength,
              'available_deduct_amount': totalAvailableAmount,
              'freeze_deduct_amount': totalFreezeAmount,
              'deducted_amount': totalDeductedAmount,
            })
          }
          this.title = '预收款开票统计'
          this.sumVisible = true
        })
      } else {
        await request.common('getInvoiceAmountTotal', params).then((data) => {
          let totalLength = 0
          let totalTaxedAmount = 0
          let totalUntaxedAmount = 0
          for (const i in data.data) {
            if (data.data.hasOwnProperty(i)) {
              totalLength += data.data[i].length
              totalTaxedAmount += data.data[i].total
              totalUntaxedAmount += data.data[i].untaxed_amount
              this.amountStatistics.push(data.data[i])
            }
          }
          if (totalLength) {
            this.amountStatistics.push({
              'status': -1, // -1 为 总计 列，需单独处理显示文字
              'length': totalLength,
              'untaxed_amount': totalUntaxedAmount,
              'total': totalTaxedAmount,
            })
          }
          this.title = '开票统计'
          this.sumVisible = true
        })
      }
    },
    changeDeductionStatus () {
      if (this.search.deduction_status * 1 === 1) {
        if (this.search.status.length === 0) {
          this.search.status = ['7']
        }
      }
    },
    isShowAbandonBtn (item) {
      return (item.deduct_detail_status_list.includes(1)) && this.user.id * 1 === item.initiator * 1
    },
    isShowApproveBtn (item) {
      // 超管和指定的bu审批人可以看到按钮
      return (item.deduct_detail_status_list.includes(1)) &&
        (this.user.id * 1 === item.bu_approver * 1 || this.user.usertype * 1 === 1)
    },
    isShowDeductBtn (item) {
      return item.issued_type * 1 === 2 && item.status * 1 === 7
    },

    amountStyle (row) {
      return (row.untaxed_amount * 1 > 0 && [11, 14, 17].includes(row.status * 1)) || row.untaxed_amount < 0 ? 'color:red;' : ''
    },
    redirectToApproveTable () {
      this.$router.push({path: '/invoice-apply/approval'})
    },
    isSearchItemDisplay () {
      return this.$route.meta.type !== 'approval'
    },
    showRefundStatus (row) {
      if ([6, 7, 8].includes(row.status)) {
        return (this.receivedPaymentStatus.find(item => item.value === row.received_payment_status) || {}).label
      } else {
        return '-'
      }
    },
    batchDownloadPdf () {
      request.common('batchDownloadInvoicePdfs', {id: this.mulSelection}).then((data) => {
        let filename = data.data
        let api = request.items.downloadPdfFileFromServer({filename: filename})
        downloadJS(api, false, false, {
          'SJ-Auth-Token': getToken()
        })
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.paymentCompanies = this.expandData(data.payment_apply_our_company_source)
      })
    },
    expandData (data) {
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    createInvoiceApply () {
      request.loading('getuserAccountDetailByUserID', {id: this.user.id}).then(({data}) => {
        if (data.length) {
          this.$router.push('/invoice-apply/create')
        } else {
          throw Error('请联系人事或管理员将您更新至员工账户列表')
        }
      }).catch((_) => {
        this.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', {type: 'warning'}).then(() => {
        })
      })
    }
  },
}
</script>

<style lang="scss">
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/InvoiceApplyNewTable.vue